import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Toast } from "react-bootstrap";
import img_phone from "../../assets/images/contact/phone.png";
import img_email from "../../assets/images/contact/email.png";
import img_people from "../../assets/images/contact/people.webp";
import "./index.css";
import { CONTACT_EMAIL, CONTACT_PHONE_NUMBER } from "../../constant/index";
import { useTranslation } from "react-i18next";
import { supabase } from "../../lib/supabaseClient";

const ContactUs = () => {
  const { t } = useTranslation();
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async () => {
    if (!message.trim()) {
      setToastMessage(t("contact.emptyMessage"));
      setIsSuccess(false);
      setShowToast(true);
      return;
    }

    setIsLoading(true);
    try {
      const { error } = await supabase
        .from("feedback")
        .insert([{ message, category: "web" }]);

      if (error) throw error;

      setToastMessage(t("contact.successMessage"));
      setIsSuccess(true);
      setMessage(""); // 清空输入框
    } catch (error) {
      console.error("Error:", error);
      setToastMessage(t("contact.errorMessage"));
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
      setShowToast(true);
    }
  };

  return (
    <Container fluid className="container contact">
      <Row className="contact-section">
        <Col>
          {/* 图片和标题部分 */}
          <img
            src={img_people}
            alt="Contact Illustration"
            style={{
              width: "150px",
              marginBottom: "16px",
            }}
          />
          <h1
            className="fw-bold"
            style={{
              fontSize: "2rem",
              fontFamily: `Peace Sans, sans-serif`,
              lineHeight: "1.2",
              marginBottom: "15px",
            }}
          >
            {t("contact.title")}
          </h1>
          <Button
            href="https://calendly.com/ikiai-support/30min"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundColor: "#7576ef",
              border: "none",
              padding: "10px 20px",
              marginBottom: "20px",
              borderRadius: "8px",
              fontFamily: "SourceHanSansCN Normal",
              fontSize: "1rem"
            }}
          >
            {t("contact.bookMeeting")}
          </Button>
          <p
            style={{
              fontSize: "1rem",
              fontFamily: `SourceHanSansNormal, sans-serif`,
              lineHeight: "1.6",
              color: "#343434",
            }}
          >
            {t("contact.description")}
          </p>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={6}>
          {/* 联系方式部分 */}
          <div className="mb-2">
            <img
              src={img_email}
              alt="Email"
              style={{
                width: "25px",
                height: "25px",
                marginRight: "10px",
              }}
            />
            <span
              style={{
                fontSize: "1rem",
                fontWeight: "500",
                color: "#343434",
              }}
            >
              {CONTACT_EMAIL}
            </span>
          </div>
          <div className="d-flex align-items-center">
            <img
              src={img_phone}
              alt="Phone"
              style={{
                width: "25px",
                height: "25px",
                marginRight: "10px",
              }}
            />
            <span
              style={{
                fontSize: "1rem",
                fontWeight: "500",
                color: "#343434",
              }}
            >
              {CONTACT_PHONE_NUMBER}
            </span>
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={24}>
          <Form onSubmit={(e) => e.preventDefault()}>
            <div style={{ position: "relative" }}>
              <Form.Control
                as="textarea"
                rows={5}
                placeholder={t("contact.placeholder")}
                className="border rounded-16"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                style={{
                  fontSize: "1rem",
                  padding: "15px",
                  paddingRight: "80px",
                  resize: "none",
                  borderRadius: "16px",
                  border: "1 #c3cacf",
                }}
              />
              <Button
                variant="primary"
                onClick={handleSubmit}
                disabled={isLoading}
                style={{
                  position: "absolute",
                  right: "10px",
                  bottom: "10px",
                  backgroundColor: "transparent",
                  border: "none",
                  fontSize: "0.9rem",
                  color: "#7576ef",
                  fontFamily: "SourceHanSansCN Normal",
                  padding: "6px 12px",
                  borderRadius: "5px",
                }}
              >
                {isLoading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  t("contact.send")
                )}
              </Button>
            </div>
          </Form>
        </Col>
      </Row>

      {/* Toast 提示 */}
      <Toast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={3000}
        autohide
        style={{
          position: "fixed",
          bottom: 20,
          right: 20,
          minWidth: "200px",
          background: isSuccess ? "#DFF2BF" : "#FFD2D2",
          color: isSuccess ? "#4F8A10" : "#D8000C",
        }}
      >
        <Toast.Body>{toastMessage}</Toast.Body>
      </Toast>
    </Container>
  );
};

export default ContactUs;
